export default "__VITE_ASSET__CgbusT5f__"